import {useMutation} from '@apollo/react-hooks';

import type {
    PublishForm as PublishFormMutation,
    PublishFormVariables as PublishFormMutationVariables,
    FormPublishInput,
} from 'nutshell-graphql-types';

import PUBLISH_FORM from '../mutations/publish-form.graphql';

export function usePublishForm(): (arg1: FormPublishInput) => Promise<any> {
    const [publishForm] = useMutation<PublishFormMutation, PublishFormMutationVariables>(
        PUBLISH_FORM
    );

    return (input: FormPublishInput) => {
        return publishForm({
            variables: {input},
        });
    };
}
